import { writable } from "svelte/store";

export type ErrorState = "OK" | "Error";
export type ErrorDetails = Error | string | unknown | null;

export const errorState = writable<ErrorState>("OK");
export const errorDetails = writable<ErrorDetails>(null);
